module.exports = __webpack_public_path__ + "img/codigorojo.a16d633a.gif";